import { IConComponents } from '@/modules/adjusterReportModules/IncidentParticipants/assets/iconComponents/iconComponents.type';
import React from 'react';

const VisitInformation: React.FC<IConComponents> = ({
  fill,
  stroke,
  height = '42',
  width = '42',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21" r="21" fill={fill} />
      <path
        d="M17 11V14"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 11V14"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 22H24"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 26H21"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 12.5C28.33 12.68 30 13.95 30 18.65V24.83C30 28.95 29 31.01 24 31.01H18C13 31.01 12 28.95 12 24.83V18.65C12 13.95 13.67 12.69 17 12.5H25Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default VisitInformation;
